import { render, staticRenderFns } from "./FormLookupPegawai.vue?vue&type=template&id=1d472814&"
import script from "./FormLookupPegawai.vue?vue&type=script&lang=js&"
export * from "./FormLookupPegawai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports